import React from 'react';
import styled from 'styled-components';
import HelpIcon from '../../Images/help-icon.svg';

const HelpButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #f5f8fd;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: auto;
  
  &:hover {
    background-color: #edf2ff;
  }
  
  @media (max-width: 768px) {
    width: 26px;
    height: 26px;
  }
`;

const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    filter: brightness(0) saturate(100%) invert(34%) sepia(15%) saturate(1133%) hue-rotate(179deg) brightness(88%) contrast(88%);
  }
  
  @media (max-width: 768px) {
    width: 14px;
    height: 14px;
  }
`;

const HelpButton = ({ onClick }) => {
  return (
    <HelpButtonContainer onClick={onClick}>
      <IconWrapper>
        <img src={HelpIcon} alt="Help" />
      </IconWrapper>
    </HelpButtonContainer>
  );
};

export default HelpButton; 